import constants from '../../../Constants';
import XmlDomUtils from '../../../utils/XmlDomUtils';
import interactionParserUtils from './InteractionParserUtils';

const pciParser = {
    parse(interactionNode, language, defaultLanguage, responseDeclarations, templateDeclarations) {
        const interactionAttrs = XmlDomUtils.getAttributes(interactionNode);

        const pciNode = interactionNode.getElementsByTagName('portableCustomInteraction')[0];
        const templateVariableNodes = pciNode.getElementsByTagName('templateVariable');
        const propertiesNode = pciNode.getElementsByTagName('properties')[0];
        const propertyList = interactionParserUtils.parseListOfChildren(propertiesNode, 'property', language, defaultLanguage);
        const modulesNode = pciNode.getElementsByTagName('modules')[0];
        const markup = interactionParserUtils.parseListOfChildren(pciNode, 'markup', language, defaultLanguage)[0].content;

        const properties = {};
        propertyList.forEach((propertyEntry) => {
            properties[propertyEntry.key] = propertyEntry.content;
        });

        const templateVariables = {};
        Array.from(templateVariableNodes).forEach((templateVariableNode) => {
            const templateIdentifier = templateVariableNode.getAttribute('templateIdentifier');
            const templateDeclarationForVariableList = templateDeclarations.filter(eR => eR.identifier === templateIdentifier);

            if (templateDeclarationForVariableList.length > 0) {
                templateVariables[templateIdentifier] = this.parseBaseTypedValue(templateDeclarationForVariableList[0]);
            }
        });

        const responseDeclarationForInteraction = responseDeclarations
            .filter(eR => eR.identifier === interactionAttrs.responseIdentifier)[0];
        const boundTo = {
            [interactionAttrs.responseIdentifier]: this.parseBaseTypedValue(responseDeclarationForInteraction),
        };

        const extraResponseDeclarations = responseDeclarations.filter(eR => eR.identifier === 'RESPONSE_state');

        // turning into string if it was automatically transformed to JSON by the server output.
        if (extraResponseDeclarations.length &&
            extraResponseDeclarations[0].defaultValue &&
            extraResponseDeclarations[0].defaultValue.length &&
            extraResponseDeclarations[0].defaultValue[0] !== null &&
            typeof extraResponseDeclarations[0].defaultValue[0] !== 'string') {
            extraResponseDeclarations[0].defaultValue[0] = JSON.stringify(extraResponseDeclarations[0].defaultValue[0]);
        }

        // should be 'pciTool'
        const mainModule = interactionParserUtils
            .parseListOfChildren(modulesNode, 'module', language, defaultLanguage)[0].id;


        return {
            prompt: interactionParserUtils.getPrompt(interactionNode, language, defaultLanguage),
            type: constants.interactionType.PORTABLE_CUSTOM_INTERACTION,
            properties,
            templateVariables,
            boundTo,
            markup,
            extraResponseDeclarations,
            mainModule,
            typeIdentifier: pciNode.getAttribute('customInteractionTypeIdentifier'),
            simpleCardinality: this.parseSimpleCardinality(responseDeclarationForInteraction.cardinality),
        };
    },

    parseSimpleCardinality(cardinality) {
        return cardinality === 'single' ? constants.pciCardinality.BASE : constants.pciCardinality.LIST;
    },

    /**
     * Retrieves an object that complies to Appendix A - Base Types of spec: http://bit.ly/2uk1avr
     * @param responseDeclarationForVariable
     * @returns {{ 'base'|'list': {
     *     specificBaseType: valueParsedBasedOnBaseTypeAndCardinality
     *  }}}
     */
    parseBaseTypedValue(responseDeclarationForVariable) {
        const baseOrList = this.parseSimpleCardinality(responseDeclarationForVariable.cardinality);
        const isSingle = baseOrList === constants.pciCardinality.BASE;
        const baseType = responseDeclarationForVariable.baseType;
        const defaultValue = responseDeclarationForVariable.defaultValue;

        const parsedValues = defaultValue.map((oneValue) => {
            return interactionParserUtils.parseValueBasedOnBaseType(baseType, oneValue);
        });

        let value = null;
        if (parsedValues.length) {
            value = isSingle ? parsedValues[0] : parsedValues;
        } else {
            value = isSingle ? null : [];
        }

        return {
            [baseOrList]: {
                [baseType]: value,
            },
        };
    },
};

export default pciParser;
